export const SAVE_BOX = "box/SAVE_BOX";
export const SAVE_BOX_SUCCESS = "box/SAVE_BOX_SUCCESS";
export const SAVE_BOX_ERROR = "box/SAVE_BOX_ERROR";

export const UPDATE_BOX = "box/UPDATE_BOX";
export const UPDATE_BOX_SUCCESS = "box/UPDATE_BOX_SUCCESS";
export const UPDATE_BOX_ERROR = "box/UPDATE_BOX_ERROR";
